import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Iam jaguaro estis tute flava, kiel leono. 
      Sed lia karaktero estis la sama, kiel nun: la plej feroca besto en ĝangalo.
    </p>

    <p class="mb-3">
      Ĉio viva timis jaguaron. 
      Sed foje sur lian felon eksidis papilio. 
      Ĉarma bruna papilio kun grandaj duonrondaj flugiloj. 
      Ŝi movis ilin, kiel du malgrandajn ventumilojn, kaj la jaguaro tuj eksentis teneran blovon. 
      Al li fariĝis tiel agrable, kvazaŭ iu karesas lian dorson. Neniu antaŭe karesis lin; oni nur timis kaj malamis.
    </p>

    <p class="mb-3">
      Li volis, ke la papilio ne forflugu, ke ŝi ĉiam restu kun li kaj tenere tuŝu lian haŭton. 
      Kaj ankaŭ al papilio ekplaĉis sidi sur la dorso de jaguaro: tiam ĉiuj rimarkis ŝin, tian etan kaj brunan antaŭe; sed subite oni komprenis, ke ŝi estas rave bela, kaj ŝiaj flugiloj nuancas de oro.
    </p>

    <p class="mb-3">
      Do, la jaguaro kaj la papilio decidis ne disiĝi plu; kaj baldaŭ la tuta felo de jaguaro kovrĝis per bela aro de papilioj, idaro de tiu unua.
    </p>

    <p class="mb-3">
      Tial la jaguaro nun havas felon kun brunaj makuloj.
    </p>
    `
  )
}

const itemName = {
  esp: 'Kial jaguaro havas felon kun makuloj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item; 